import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["password", "passwordConfirmation"]

  connect() {
    this.validate()
  }

  validate() {
    if (this.hasPasswordTarget && this.hasPasswordConfirmationTarget) {
      const password = this.passwordTarget.value
      const confirmation = this.passwordConfirmationTarget.value

      if (password !== confirmation) {
        this.passwordConfirmationTarget.setCustomValidity('Passwords do not match')
      } else {
        this.passwordConfirmationTarget.setCustomValidity('')
      }
    }
  }

  validateOnSubmit(event) {
    this.validate()
    if (this.hasPasswordConfirmationTarget && !this.passwordConfirmationTarget.checkValidity()) {
      event.preventDefault()
      this.passwordConfirmationTarget.reportValidity()
      return false
    }
  }
}
